/**
 * Production tenant root domain SSOT.
 * Override via TENANT_ROOT_DOMAIN (API) or VITE_TENANT_ROOT_DOMAIN (frontend build).
 */
export const DEFAULT_TENANT_ROOT_DOMAIN = 'inflomatrix.app' as const;

/** Legacy platform zone — custom domain registration must reject both. */
export const LEGACY_TENANT_ROOT_DOMAIN = 'inflomatrix.com' as const;

export const PLATFORM_RESERVED_ROOT_DOMAINS = [
  DEFAULT_TENANT_ROOT_DOMAIN,
  LEGACY_TENANT_ROOT_DOMAIN,
] as const;

/** Strip scheme, path, port, trailing dot from env or user input. */
export function normalizeRootDomain(raw: string | null | undefined): string | null {
  const trimmed = raw?.trim();
  if (!trimmed) return null;

  let value = trimmed.toLowerCase();
  value = value.replace(/^https?:\/\//, '');
  value = (value.split('/')[0] ?? value).split(':')[0] ?? value;
  value = value.replace(/\.$/, '');

  return value || null;
}

export function resolveTenantRootDomain(envValue?: string | null): string {
  return normalizeRootDomain(envValue) ?? DEFAULT_TENANT_ROOT_DOMAIN;
}

export function isPlatformReservedHostname(hostname: string): boolean {
  const host = normalizeRootDomain(hostname) ?? hostname.trim().toLowerCase().replace(/\.$/, '');
  return PLATFORM_RESERVED_ROOT_DOMAINS.some((root) => host === root || host.endsWith(`.${root}`));
}
